import React, { Component } from 'react';
import { Button } from 'reactstrap';
import './AddSkuToolBar.css';
import { IconPlus, IconRemove } from '../../Icons/Icons';

const HotSpot = ({
  hotspot,
  onChange,
  onDragSkuStart,
  onDragEnd,
  removeHotspot
}) => {
  const draggableProps = !hotspot.isActive
    ? {
        draggable: true,
        onDragStart: evt => onDragSkuStart({ evt, sku: hotspot.sku }),
        onDragEnd: onDragEnd
      }
    : null;

  return (
    <div
      key={hotspot.order}
      className={`hotspot ${hotspot.isActive ? 'is-active' : ''}`}
      {...draggableProps}
    >
      <div>
        <input
          onChange={evt =>
            onChange({ sku: hotspot.sku, value: evt.target.value })
          }
          value={hotspot.sku}
        />
        <div className="button">
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => removeHotspot(hotspot.sku)}
            title="Remove"
          >
            <IconRemove />
          </Button>
        </div>
      </div>
    </div>
  );
};
class AddSkuToolBar extends Component {
  render() {
    const { hotspots, addHotspot } = this.props;

    const hotspotEvents = {
      onChange: this.props.onChange,
      onDragSkuStart: this.props.onDragSkuStart,
      onDragEnd: this.props.onDragEnd,
      removeHotspot: this.props.removeHotspot
    };

    const activeHotspots = hotspots
      .filter(hotspot => hotspot.isActive)
      .map((hotspot, index) => (
        <HotSpot key={`${index}-active`} {...hotspotEvents} hotspot={hotspot} />
      ));
    const inactiveHotspots = hotspots
      .filter(hotspot => !hotspot.isActive)
      .map((hotspot, index) => (
        <HotSpot
          key={`${index}-inactive`}
          {...hotspotEvents}
          hotspot={hotspot}
        />
      ));

    return (
      <div className="add-skus">
        <div className="list">
          <div>{activeHotspots.length > 0 && activeHotspots}</div>
          <div>{inactiveHotspots.length > 0 && inactiveHotspots}</div>
        </div>

        <div>
          <hr />
          <Button color="primary" outline onClick={() => addHotspot()}>
            <IconPlus />
            Add hotspot
          </Button>
        </div>
      </div>
    );
  }
}

export default AddSkuToolBar;



// WEBPACK FOOTER //
// ./src/components/library/LookBook/AddSkuToolBar.js